export enum PersonalityType {
    SHY = "shy",
    RISK_TAKER = "risk-taker",
    EXTROVERT = "extrovert",
    ATHLETIC = "athletic",
    KIND_HELPFUL = "kind-helpful",
}
